import gql from "graphql-tag";

export default gql(`
mutation updateGame1($id: ID! $playerId: String $score: Int $playerDisplayName: String $round: Int) {
    updateGame1 (input: {
      id : $id
  
      Player_1 : $playerId
      Player_1_Score : $score
      Player_1_DisplayName : $playerDisplayName
      Player_1_Round : $round
  
    }) {
      id
      RoundTotal
      RoundCurrent
      DateStart
      Player_1
      Player_1_Score
      Player_1_DisplayName
      Player_1_Round
      Player_2
      Player_2_Score
      Player_2_DisplayName
      Player_2_Round
      Player_3
      Player_3_Score
      Player_3_DisplayName
      Player_3_Round
      Player_4
      Player_4_Score
      Player_4_DisplayName
      Player_4_Round
    }
    }
`);